// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule__condition_checked_not_auto[data-v-188ecf6a] {\n  color: #0066ff;\n}", ""]);
// Exports
module.exports = exports;
